import { Design } from '@app/types';

/** Normalize @see DesignModule entries in @see Design.components.modules. */
export function normalizeModules(serialized: Design) {
  serialized.components.modules.forEach((appModule) => {
    appModule.localVariables ??= [];
  });
}
